import React from "react";
import { any, arrayOf, bool, func } from "prop-types";
import { Typography, Divider, CircularProgress } from "@material-ui/core";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import IntlMessage from "../../helpers/IntlMessage";
import DrawerModal from "components/DrawerModal";
import { ColorPattern } from "./ColorPattern";
import { CreateTagAutoComplete } from "../../components/CreateTagAutoComplete";
import { changeAlphaOfColor } from "./colorUtils";
import styles from "./style.module.scss";

function TagEditDrawer({
  open,
  onClose,
  imageTags,
  isFetchingData,
  onRemoveTag,
  onChangeTagAutoComplete,
  onChangeColor,
}) {
  return (
    <DrawerModal
      title={<IntlMessage id="common.smart-tag" />}
      open={open}
      toggle={onClose}
    >
      {isFetchingData ? (
        <div className={styles.loadingContainer}>
          <CircularProgress size={30} />
        </div>
      ) : (
        <>
          {/* Selected Tags Section */}
          <div className={styles.drawerSectionHeader}>
            <div className={styles.drawerTitleRow}>
              <Typography variant="h2" className={styles.drawerSectionTitle}>
                <IntlMessage id="common.selected-tags-title" />
              </Typography>
              <Typography variant="h2" className={styles.drawerTagCount}>
                ({imageTags ? imageTags.length : 0})
              </Typography>
            </div>
          </div>

          <Typography variant="h4" className={styles.drawerSubtitle}>
            <IntlMessage id="common.selected-tags-subtitle" />
          </Typography>

          <div className={styles.selectedTagsContainer}>
            {imageTags?.map((item) => (
              <div
                key={item.tagId}
                className={styles["tag-wrapper"]}
                style={{
                  backgroundColor: changeAlphaOfColor(item.color, 0.2),
                }}
              >
                <span style={{ color: item.color }}>{item.tagName}</span>
                <CancelRoundedIcon
                  className={styles["delete-one-tag-btn"]}
                  fontSize="small"
                  onClick={() => onRemoveTag([item])}
                />
              </div>
            ))}
          </div>

          <Divider className={styles.drawerDivider} />

          {/* Create Tag Section */}
          <div>
            <Typography variant="h2" className={styles.drawerSectionTitle}>
              <IntlMessage id="common.create-smart-tag-title" />
            </Typography>
            <Typography variant="h4" className={styles.drawerSubtitle}>
              <IntlMessage id="common.create-smart-tag-subtitle" />
            </Typography>
          </div>

          <div className={styles.drawerFieldGroup}>
            <Typography variant="h2" className={styles.drawerFieldLabel}>
              <IntlMessage id="common.color-pattern-title" />
            </Typography>
          </div>
          <ColorPattern onChange={onChangeColor} />

          <div className={styles.drawerFieldGroup}>
            <Typography variant="h2" className={styles.drawerFieldLabel}>
              <IntlMessage id="common.tag-name-title" />
            </Typography>
          </div>
          <CreateTagAutoComplete
            onChange={onChangeTagAutoComplete}
            allowAdd={true}
            value={null}
            placeholder={<IntlMessage id="common.search-or-create-tag" />}
          />
        </>
      )}
    </DrawerModal>
  );
}

TagEditDrawer.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  imageTags: arrayOf(any),
  isFetchingData: bool,
  onRemoveTag: func.isRequired,
  onChangeTagAutoComplete: func.isRequired,
  onChangeColor: func.isRequired,
};

export default TagEditDrawer;
